/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkbox_profile[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0a9be2}.checkbox_profile.flex[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:16px;text-align:left;line-height:22px;margin-bottom:0}\n/*# sourceMappingURL=coupons.component.css.map*/"];
export { styles as styles };
